// extracted by mini-css-extract-plugin
module.exports = {"client":"DetailTabsContainer-module__client--Uu5xS","header":"DetailTabsContainer-module__header--fY91T","headerText":"DetailTabsContainer-module__headerText--2Betj"};